export default __webpack_public_path__ + "assets/images/amex.bb9a79beafa74a4eda10892d46aee522.svg";